/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkuUpdateBarcodeItem
 */
export interface SkuUpdateBarcodeItem {
    /**
     * 条码主键ID（新增时不传，更新时必传）
     * @type {number}
     * @memberof SkuUpdateBarcodeItem
     */
    id?: number;
    /**
     * 条形码编号（必填，不可为空白）
     * @type {string}
     * @memberof SkuUpdateBarcodeItem
     */
    marketBarcode?: string;
    /**
     * 条形码商品名称
     * @type {string}
     * @memberof SkuUpdateBarcodeItem
     */
    marketProductName?: string;
    /**
     * 条形码选项名
     * @type {string}
     * @memberof SkuUpdateBarcodeItem
     */
    marketOptionName?: string;
    /**
     * 条形码选项ID
     * @type {string}
     * @memberof SkuUpdateBarcodeItem
     */
    marketOptionId?: string;
    /**
     * 第三方电商平台ID
     * @type {number}
     * @memberof SkuUpdateBarcodeItem
     */
    businessPlatformId?: number;
}

/**
 * Check if a given object implements the SkuUpdateBarcodeItem interface.
 */
export function instanceOfSkuUpdateBarcodeItem(value: object): value is SkuUpdateBarcodeItem {
    return true;
}

export function SkuUpdateBarcodeItemFromJSON(json: any): SkuUpdateBarcodeItem {
    return SkuUpdateBarcodeItemFromJSONTyped(json, false);
}

export function SkuUpdateBarcodeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuUpdateBarcodeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProductName': json['marketProductName'] == null ? undefined : json['marketProductName'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'businessPlatformId': json['businessPlatformId'] == null ? undefined : json['businessPlatformId'],
    };
}

export function SkuUpdateBarcodeItemToJSON(json: any): SkuUpdateBarcodeItem {
    return SkuUpdateBarcodeItemToJSONTyped(json, false);
}

export function SkuUpdateBarcodeItemToJSONTyped(value?: SkuUpdateBarcodeItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'marketBarcode': value['marketBarcode'],
        'marketProductName': value['marketProductName'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'businessPlatformId': value['businessPlatformId'],
    };
}

